"use client";

import { sha256 } from "js-sha256";
import Cookies from "js-cookie";

import { TikTokPropertyType } from "~/services/api/services/types/EventsEnum";
import { COOKIES } from "~/types/Cookie";

type UserDataParams = {
    ip: string | undefined;
    user_agent: string | undefined;
    email?: string | null;
    phone?: string | null;
    external_id?: string | null;
};

export function sendTikTokEvent(sendTikTokEvent, args) {
    const user_data: UserDataParams = {
        ip: Cookies.get(COOKIES.IP_ADDRESS),
        user_agent: navigator.userAgent,
    };

    if (args.email) {
        user_data.email = sha256(args.email);
    }

    if (args.phone) {
        user_data.phone = sha256(args.phone);
    }

    if (args.external_id) {
        user_data.external_id = sha256(args.external_id);
    }

    sendTikTokEvent({
        type: TikTokPropertyType.TIKTOK_EVENT,
        properties: {
            event_source: "web",
            event_source_id: "D0N1VFBC77U59RIC662G",
            event_id: args.event_id,
            data: [{
                event: args.event_name,
                event_id: args.event_id || Date.now().toString(),
                event_time: Math.floor(Date.now() / 1000),
                user: user_data,
                properties: args.properties || {},
                page: {
                    "url": window.location.href,
                    "referrer": document.referrer,
                }
            }],
        },
    });

    return null;
}
